let dataLayer = window.dataLayer || [];

let IsaGtmEcommerce = {};

IsaGtmEcommerce.Catalog = '';
IsaGtmEcommerce.Category = '';
IsaGtmEcommerce.CurrencyCode = '';
IsaGtmEcommerce.MemberType = '';
IsaGtmEcommerce.MemberId = '';
IsaGtmEcommerce.CultureCode = '';
IsaGtmEcommerce.RecognitionRank = '';
IsaGtmEcommerce.MarketingCloudUserId = '';
IsaGtmEcommerce.IsagenixMemberSubType = '';
IsaGtmEcommerce.PreferredCultureCode = '';
IsaGtmEcommerce.HasAutoship = '';
IsaGtmEcommerce.CanEnroll = '';
IsaGtmEcommerce.HasIsaDelivery = '';
IsaGtmEcommerce.DaysSinceEnrollment = '';

function productToProductDetails(product) {
    if(product.category) {
        IsaGtmEcommerce.Category = product.category;
    }
    let updatedProduct = {
        'name': product.name,
        'id': product.id,
        'price': formatPrice(product.price),
        'brand': 'Isagenix',
        'category': IsaGtmEcommerce.Category
    };
    if(typeof product.queryId === 'string' && product.queryId.trim() !== '') {
        updatedProduct.queryId = product.queryId;
    }

    if(typeof product.indexName === 'string' && product.indexName.trim() !== '') {
        updatedProduct.indexName = product.indexName;
    }

    if(typeof product.purchaseType === 'string' && product.purchaseType.trim() !== '') {
        updatedProduct.purchaseType = product.purchaseType;
    }

    return updatedProduct;
}

function productToCartProduct(product) {
    var addToCartProduct = productToProductDetails(product);

    addToCartProduct.quantity = product.quantity;

    if(product.pakQualifier) {
        addToCartProduct.variant = product.pakQualifier;
    }

    return addToCartProduct;
}

export function setDataForAllProducts(catalog, category, currencyCode, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment) {
    IsaGtmEcommerce.Catalog = catalog;
    IsaGtmEcommerce.Category = category;
    IsaGtmEcommerce.CurrencyCode = currencyCode;
    IsaGtmEcommerce.MemberType = memberType;
    IsaGtmEcommerce.MemberId = memberId;
    IsaGtmEcommerce.CultureCode = cultureCode;
    IsaGtmEcommerce.MarketingCloudUserId = marketingCloudUserId;
    IsaGtmEcommerce.IsagenixMemberSubType = isagenixMemberSubType;
    IsaGtmEcommerce.PreferredCultureCode = preferredCultureCode;
    IsaGtmEcommerce.HasAutoship = hasAutoship;
    IsaGtmEcommerce.CanEnroll = canEnroll;
    IsaGtmEcommerce.HasIsaDelivery = hasIsaDelivery;
    IsaGtmEcommerce.DaysSinceEnrollment = daysSinceEnrollment;
}

export function setGenericData(catalog, memberType, memberId, cultureCode, preferredCultureCode) {
    IsaGtmEcommerce.Catalog = catalog;
    IsaGtmEcommerce.MemberType = memberType;
    IsaGtmEcommerce.MemberId = memberId;
    IsaGtmEcommerce.CultureCode = cultureCode;
    IsaGtmEcommerce.PreferredCultureCode = preferredCultureCode;
}

export function productDetails(products) {
    var dataObj = {
        'event': 'productView',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.MemberId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'isagenixMemberSubType': IsaGtmEcommerce.IsagenixMemberSubType,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'hasAutoship': IsaGtmEcommerce.HasAutoship,
        'canEnroll': IsaGtmEcommerce.CanEnroll,
        'hasIsaDelivery': IsaGtmEcommerce.HasIsaDelivery,
        'daysSinceEnrollment': IsaGtmEcommerce.DaysSinceEnrollment,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'detail': {
                'products': [productToProductDetails(products)]
            }
        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function addGtmTagForEditCart(products) {
    var dataObj = {
        'event': 'editCartItem',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.MemberId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'isagenixMemberSubType': IsaGtmEcommerce.IsagenixMemberSubType,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'hasAutoship': IsaGtmEcommerce.HasAutoship,
        'canEnroll': IsaGtmEcommerce.CanEnroll,
        'hasIsaDelivery': IsaGtmEcommerce.HasIsaDelivery,
        'daysSinceEnrollment': IsaGtmEcommerce.DaysSinceEnrollment,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'detail': {
                'products': [productToProductDetails(products)]
            }
        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function addGtmTagToCart(products, eventName = 'addToCart') {
    var dataObj = {
        'event': eventName,
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.MemberId,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'isagenixMemberSubType': IsaGtmEcommerce.IsagenixMemberSubType,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'hasAutoship': IsaGtmEcommerce.HasAutoship,
        'canEnroll': IsaGtmEcommerce.CanEnroll,
        'hasIsaDelivery': IsaGtmEcommerce.HasIsaDelivery,
        'daysSinceEnrollment': IsaGtmEcommerce.DaysSinceEnrollment,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'add': {
                'products': [productToCartProduct(products)]
            }
        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function removeFromCart(products) {
    let dataObj = {
        'event': 'removeFromCart',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'remove': {
                'products': products.map(productToCartProduct)
            }
        }
    };

    dataLayer.push(setTransactionFlowType(dataObj));
}

export function addGtmTagToPurchase(id, flow, total, tax, shipping, coupon, products, purchaseType, purchaseData) {
    let action = {
        'id': id,
        'affiliation': flow,
        'revenue': formatPrice(total),
        'tax': tax,
        'shipping': shipping,
        'coupon': coupon
    };
    if(typeof purchaseType === 'string' && purchaseType.trim() !== '') {
        action.purchaseType = purchaseType;
    }
    const dataObject = {
        'event': 'purchase',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.MemberId,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'isagenixMemberSubType': IsaGtmEcommerce.IsagenixMemberSubType,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'hasAutoship': IsaGtmEcommerce.HasAutoship,
        'canEnroll': IsaGtmEcommerce.CanEnroll,
        'hasIsaDelivery': IsaGtmEcommerce.HasIsaDelivery,
        'daysSinceEnrollment': IsaGtmEcommerce.DaysSinceEnrollment,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'purchase': {
                'actionField': action,
                'products': products.map(productToCartProduct)
            }
        }
    };

    if(purchaseData && purchaseData !== null) {
        dataObject.purchaseData = purchaseData;
    }

    dataLayer.push(setTransactionFlowType(dataObject));
}

export function addGtmTagForPaymentInfo(products) {
    var dataObj = {
        'event': 'startPaymentInfo',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.MemberId,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'isagenixMemberSubType': IsaGtmEcommerce.IsagenixMemberSubType,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'hasAutoship': IsaGtmEcommerce.HasAutoship,
        'canEnroll': IsaGtmEcommerce.CanEnroll,
        'hasIsaDelivery': IsaGtmEcommerce.HasIsaDelivery,
        'daysSinceEnrollment': IsaGtmEcommerce.DaysSinceEnrollment,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'products': products.map(productToCartProduct)

        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function addGtmTagForReviewPage(step, products) {
    var dataObj = {
        'event': 'orderReview',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.MemberId,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'isagenixMemberSubType': IsaGtmEcommerce.IsagenixMemberSubType,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'hasAutoship': IsaGtmEcommerce.HasAutoship,
        'canEnroll': IsaGtmEcommerce.CanEnroll,
        'hasIsaDelivery': IsaGtmEcommerce.HasIsaDelivery,
        'daysSinceEnrollment': IsaGtmEcommerce.DaysSinceEnrollment,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'checkout': {
                'actionField': { 'step': step }
            },
            'products': products.map(productToCartProduct)

        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function addGtmTagTocheckout(step, products) {
    var dataObj = {
        'event': 'checkoutOption',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.MemberId,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'isagenixMemberSubType': IsaGtmEcommerce.IsagenixMemberSubType,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'hasAutoship': IsaGtmEcommerce.HasAutoship,
        'canEnroll': IsaGtmEcommerce.CanEnroll,
        'hasIsaDelivery': IsaGtmEcommerce.HasIsaDelivery,
        'daysSinceEnrollment': IsaGtmEcommerce.DaysSinceEnrollment,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'checkout': {
                'actionField': { 'step': step }
            },
            'products': products.map(productToCartProduct)

        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function checkoutOption(step, option) {
    var dataObj = {
        'event': 'checkoutOption',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'checkout_option': {
                'actionField': { 'step': step, 'option': option }
            }
        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function startEnroll() {
    var dataObj = {
        'event': 'startEnroll',
        'catalog': IsaGtmEcommerce.Catalog,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.memberId,
        'timestamp': new Date().toISOString()
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function completeEnroll() {
    var dataObj = {
        'event': 'completeEnroll',
        'catalog': IsaGtmEcommerce.Catalog,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.memberId,
        'timestamp': new Date().toISOString()
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function startFindAFriend() {
    var dataObj = {
        'event': 'startFindAFriend',
        'catalog': IsaGtmEcommerce.Catalog,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'membertype': IsaGtmEcommerce.MemberType
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function completeFindAFriend(referralType, heardAboutUs = null, otherValue = null) {
    let dataObj = {
        event: 'completeFindAFriend',
        referralType: referralType,
        catalog: IsaGtmEcommerce.Catalog,
        cultureCode: IsaGtmEcommerce.CultureCode,
        preferredCultureCode: IsaGtmEcommerce.PreferredCultureCode,
        membertype: IsaGtmEcommerce.MemberType
    };

    if(heardAboutUs) {
        dataObj.howDidYouFindUs = heardAboutUs;
    }

    if(otherValue) {
        dataObj.howDidYouFindUsOthers = otherValue;
    }

    dataLayer.push(setTransactionFlowType(dataObj));
}

export function checkUserName(username, status) {
    var dataObj = {
        'event': 'checkUsername ',
        'username': username,
        'status': status
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function addShippingInfo(shippingMethodName, cost) {
    var dataObj = {
        'event': 'addShippingInfo',
        'catalog': IsaGtmEcommerce.Catalog,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'membertype': IsaGtmEcommerce.MemberType,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'shipping': {
                'info': shippingMethodName,
                'cost': cost
            }
        }
    };

    dataLayer.push(setTransactionFlowType(dataObj));
}

export function addApplyCouponGtmTag(couponCode, isSuccessful, failureReason) {
    var dataObj = {
        'event': 'applyCoupon',
        'couponCode': couponCode,
        'status': isSuccessful ? 'success' : 'failure',
        'failureReason': isSuccessful ? '' : failureReason
    };

    dataLayer.push(setTransactionFlowType(dataObj));
}

export function paymentAndSummaryCheckoutOption(step) {
    var dataObj = {
        'event': 'checkoutOption',
        'catalog': IsaGtmEcommerce.Catalog,
        'membertype': IsaGtmEcommerce.MemberType,
        'ecommerce': {
            'currencyCode': IsaGtmEcommerce.CurrencyCode,
            'checkout': {
                'actionField': { 'step': step }
            }
        }
    };
    dataLayer.push(setTransactionFlowType(dataObj));
}

export function homePage() {
    const dataObj = {
        'event': 'homePage',
        'membertype': IsaGtmEcommerce.MemberType,
        'memberId': IsaGtmEcommerce.memberId,
        'marketingCloudUserId': IsaGtmEcommerce.MarketingCloudUserId,
        'cultureCode': IsaGtmEcommerce.CultureCode,
        'preferredCultureCode': IsaGtmEcommerce.PreferredCultureCode,
        'recognitionRank': IsaGtmEcommerce.RecognitionRank
    };

    dataLayer.push(setTransactionFlowType(dataObj));
}

export function buildDataLayerObject(gaData, eventName, isAdd) {
    const action = isAdd ? 'add' : 'remove';
    const productsArray = gaData.Products.map(item => {
        let mappedProduct = {
            name: item.ProductName,
            id: item.Sku,
            price: formatPrice(item.Price),
            brand: item.Brand,
            category: item.ProductFamilyName,
            quantity: item.Quantity
        };

        if(typeof item.queryId === 'string' && item.queryId.trim() !== '') {
            mappedProduct.queryId = item.queryId;
        }

        if(typeof item.indexName === 'string' && item.indexName.trim() !== '') {
            mappedProduct.indexName = item.indexName;
        }

        return mappedProduct;
    });

    return {
        event: eventName,
        catalog: gaData.CatalogName,
        membertype: gaData.MemberType,
        memberId: gaData.MemberId,
        marketingCloudUserId: gaData.MarketingCloudUserId,
        cultureCode: gaData.CultureCode,
        isagenixMemberSubType: gaData.IsagenixMemberSubType,
        preferredCultureCode: gaData.PreferredCultureCode,
        hasAutoship: gaData.HasAutoship,
        canEnroll: gaData.CanEnroll,
        hasIsaDelivery: gaData.HasIsaDelivery,
        daysSinceEnrollment: gaData.DaysSinceEnrollment,
        ecommerce: {
            currencyCode: gaData.CurrencyCode,
            [action]: {
                products: productsArray
            }
        }
    };
}

function formatPrice(price) {
    try {
        if(typeof price === 'string') {
            const parsed = parseFloat(price);
            if(isNaN(parsed)) return price;
            return parsed.toFixed(2);
        }

        if(typeof price === 'number') {
            return price.toFixed(2);
        }

        return price;
    } catch (e) {
        return price;
    }
}

export function addGlobalQueryIdToRequest(request, queryId) {
    if(
        request !== null &&
        typeof request === 'object' &&
        request.constructor === Object &&
        typeof queryId === 'string' &&
        queryId.trim() !== ''
    ) {
        if(window?.algoliaData?.isAllowedFlowForAlgolia) {
            request.queryId = queryId;
        }
    }
    return request;
}

export function setTransactionFlowType(dataObject) {
    if(typeof dataObject === 'object' && dataObject !== null && !('transactionflowtype' in dataObject) && window.algoliaData) {
        const transactionFlowType = window.algoliaData.transactionFlowType;
        if(transactionFlowType && transactionFlowType !== '') {
            dataObject.transactionflowtype = transactionFlowType;
        }
    }
    return dataObject;
}
